import { api } from 'api/api';
import { Endpoints } from 'api/constants';
import { IJob } from 'types/income';

interface GetJobStatus {
  queue: string;
  jobId: string;
}

export const loaders = {
  getJobStatus: ({ queue, jobId }: GetJobStatus) => {
    return api<IJob>({
      url: Endpoints.clientAdmin.jobs.status,
      params: {
        queue,
        jobId,
      },
    });
  },
};
